export function isHealthieClaimId(claimId: string): boolean {
  return /^\d+$/.test(claimId);
}
